import { IsDateString, IsEnum, IsNotEmpty } from 'class-validator';
import { Genders } from '../../administrative';

export class UserRegistrationPatchIdentityDto {
  @IsDateString()
  @IsNotEmpty()
  birthDate!: string;

  @IsEnum(Genders)
  @IsNotEmpty()
  gender!: Genders;
}
